<div class="templateBody">
  <div style="margin-top: 20px;">
    <p class="link">About</p>
    <p>The IFP Environmental Pre-screening Filter tool (PFT) is a web application designed to allow procedure
      designers, airport personnel, and environmental specialists (EPSs) to easily share information about new or
      amended procedures, and to provide recommendations on categorical exclusions (CATEXs). The procedure designer
      and airport contact provide information requested by the tool, and the environmental specialist uses this
      information to determine if the procedure request is eligible for a CATEX, or if additional screening is
      required.</p>
  </div>
</div>